import ProtectedRouteAdmin from "../components/Common/ProtectedRouteAdmin";
import BusinessProfile from "../pages/BusinessProfile";
import Dashboard from "../pages/Dashboard/Dashboard";
import Distributor from "../pages/Distributors/Distributor";
import Kits from "../pages/KitManagement/Kits";
import EditArticle from "../pages/MessageCentre/EditArticle/EditArticle";
import EditNotification from "../pages/MessageCentre/EditNotification/EditNotification";
import MessageCentre from "../pages/MessageCentre/MessageCentre";
import Notifications from "../pages/Notifications/Notification";
import Products from "../pages/Products/Products";
import ReportEditor from "../pages/ReportManagement/ReportEditor";
import Reports from "../pages/ReportManagement/Reports";
// import Resource from "../pages/ResourceManagement/Resource";
import UserManagement from "../pages/UserManagement/UserManagement/UserManagement";
import Users from "../pages/UserManagement/Users";
import Layout from "../layout";
import PublicRoute from "../components/Common/PublicRoute";
import CreateGroupReport from "../pages/ReportManagement/GroupReport";
import CreateLocation from "../pages/BusinessProfile/CreateLocation";
import UpdateUser from "../pages/UserManagement/ManageUser";
import CreateKit from "../pages/KitManagement/CreateKit";
import UploadComponentpic from "../pages/Products/ImportProducts/screen1";
import UploadComponentData from "../pages/Products/ImportProducts/screen2";
import ImportDuplicates from "../pages/Products/ImportProducts/screen3";
import ImportSummary from "../pages/Products/ImportProducts/screen4";
import GeneratePdfKit from "../components/GeneratePdfKit";
import WithOutLoginData from "../pages/WithoutLoginData";
import DistributorDashboard from "../pages/DistributorSuperAdmin/DistributorDashboard";
import DistributorUserManagement from "../pages/DistributorSuperAdmin/DistributorUsermanagement";
import DistributorBusinessProfile from "../pages/DistributorSuperAdmin/DistributorBusinessProfile";
import DistributorClients from "../pages/DistributorSuperAdmin/DistributorClients";
// import DistributorNotification from "../pages/DistributorSuperAdmin/DistributorNotification";
import Login from "../pages/Login";
import ImportCsvFiles from "../pages/ImportCsvFiles";
import ExportCsvFiles from "../pages/ExportCsvFiles";
import MultipleFileUpload from "../pages/MultipleFileUpload";
import OnlineQuickPageOne from "../pages/WithoutLoginData/QuickReportPages/OnlineQuickPageOne";
import OnlineQuickPageTwo from "../pages/WithoutLoginData/QuickReportPages/OnlineQuickPageTwo";
import OnlineQuickPageThree from "../pages/WithoutLoginData/QuickReportPages/OnlineQuickPageThree";
import QuickReportPagesLayout from "../pages/WithoutLoginData/QuickReportPages";
import DetailedReportPageOne from "../pages/WithoutLoginData/QuickReportPages/DetailedReportPageOne";
import DetailedReportSummary from "../pages/WithoutLoginData/QuickReportPages/DetailedReportSummary";
import DetailedReportTakeAction from "../pages/WithoutLoginData/QuickReportPages/DetailedReportTakeAction";
import StandardWithQuickReport from "../pages/WithoutLoginData/QuickReportPages/StandardWithQuickReport";
import DetailedReportFilledItem from "../pages/WithoutLoginData/QuickReportPages/DetailedReportFilledItem";
import DetailedIncidentReportSummary from "../pages/WithoutLoginData/QuickReportPages/DetailedIncidentReportSummary";
import DistributorInviteAdmin from "../pages/DistributorSuperAdmin/DistributorInviteAdmin";
import { permissions } from "../utils/helperFunction";
import CreateDistributionLocation from "../pages/DistributorSuperAdmin/DistributorBusinessProfile/DistributorCreateLocation";
import UpdateDistributor from "../pages/Distributors/ManageDistributor";
import DistributorUpdateUser from "../pages/DistributorSuperAdmin/ManageDistributor";
import GenerateExcelKit from "../components/GeneratePdfKit/generateExcel";
import ViewPDF from "../pages/ViewPDF";
// import DistQR from "../pages/DistributorSuperAdmin/DistributorQR";
import KitDetails from "../pages/WithoutLoginData/QuickReportPages/KitDetails";
import NearMissPageOne from "../pages/WithoutLoginData/QuickReportPages/NearMissReport/NearMissPageOne";
import ReportSummary from "../pages/WithoutLoginData/QuickReportPages/NearMissReport/ReportSummary";
import ForgotPassword from "../pages/ForgotPassword";
import ProtectedRouteDistributor from "../components/Common/ProtectedRouteDistributor";
import CreateEmptyKit from "../pages/KitManagement/CreateEmptyKit";
import Invite from "../pages/Invite";

const {
  all,
  products,
  users,
  business,
  distributors,
  resource,
  notifications,
  dist_super_admin,
  kitManagement,
  clients,
} = permissions;

const privateType = "private";
const publicType = "public";
const distributorAllAccess = [
  dist_super_admin,
  users,
  business,
  distributors,
  notifications,
  clients,
];

const RouterData = [
  {
    type: privateType,
    path: "/",
    element: (
      <ProtectedRouteAdmin
        permission={[
          all,
          products,
          users,
          business,
          distributors,
          resource,
          kitManagement,
        ]}
      >
        <Layout>
          <Dashboard />
        </Layout>
      </ProtectedRouteAdmin>
    ),
  },
  {
    type: publicType,
    path: "/login",
    element: (
      <PublicRoute>
        <Login />
      </PublicRoute>
    ),
  },
  {
    type: publicType,
    path: "/forgot-password",
    element: <ForgotPassword />,
  },
  {
    // Distributor invitation landing (opens app if installed, else store).
    type: publicType,
    path: "/invite",
    element: <Invite />,
  },
  {
    type: publicType,
    path: "/verify_email",
    element: <PublicRoute>{/* <Login /> */}</PublicRoute>,
  },
  {
    type: privateType,
    path: "/users",
    element: (
      <ProtectedRouteAdmin permission={[all, users]}>
        <Layout>
          <Users />
        </Layout>
      </ProtectedRouteAdmin>
    ),
  },
  {
    type: privateType,
    path: "/products",
    element: (
      <ProtectedRouteAdmin permission={[all, products]}>
        <Layout>
          <Products />
        </Layout>
      </ProtectedRouteAdmin>
    ),
  },
  {
    type: privateType,
    path: "/kit",
    element: (
      <ProtectedRouteAdmin permission={[all, kitManagement]}>
        <Layout>
          <Kits />
        </Layout>
      </ProtectedRouteAdmin>
    ),
  },

  {
    type: privateType,
    path: "/createkit",
    element: (
      <ProtectedRouteAdmin permission={[all, kitManagement]}>
        <Layout>
          <CreateKit />
        </Layout>
      </ProtectedRouteAdmin>
    ),
  },
  {
    type: privateType,
    path: "/createemptykit",
    element: (
      <ProtectedRouteAdmin permission={[all, kitManagement]}>
        <Layout>
          <CreateEmptyKit />
        </Layout>
      </ProtectedRouteAdmin>
    ),
  },
  {
    type: privateType,
    path: "/messaging",
    element: (
      <ProtectedRouteAdmin permission={[all]}>
        <Layout>
          <MessageCentre />
        </Layout>
      </ProtectedRouteAdmin>
    ),
  },
  // {
  //   type: privateType,
  //   path: "/editarticle",
  //   element: (
  //     <ProtectedRouteAdmin permission={[all]}>
  //       <Layout>
  //         <EditArticle />
  //       </Layout>
  //     </ProtectedRouteAdmin>
  //   ),
  // },
  {
    type: privateType,
    path: "/businessprofile",
    element: (
      <ProtectedRouteAdmin permission={[all, business]}>
        <Layout>
          <BusinessProfile />
        </Layout>
      </ProtectedRouteAdmin>
    ),
  },
  {
    type: privateType,
    path: "/edit-notification",
    element: (
      <ProtectedRouteAdmin permission={[all]}>
        <Layout>
          <EditNotification />
        </Layout>
      </ProtectedRouteAdmin>
    ),
  },
  // {
  //   type: privateType,
  //   path: "/resource",
  //   element: (
  //     <ProtectedRouteAdmin permission={[all, resource]}>
  //       <Layout>
  //         <Resource />
  //       </Layout>
  //     </ProtectedRouteAdmin>
  //   ),
  // },

  {
    type: privateType,
    path: "/distributors",
    element: (
      <ProtectedRouteAdmin permission={[all, distributors]}>
        <Layout>
          <Distributor />
        </Layout>
      </ProtectedRouteAdmin>
    ),
  },
  {
    type: privateType,
    path: "/distributorinfo",
    element: (
      <ProtectedRouteAdmin permission={[all, distributors]}>
        <Layout>
          <UpdateDistributor />
        </Layout>
      </ProtectedRouteAdmin>
    ),
  },
  {
    type: privateType,
    path: "/update-distributor/:id",
    element: (
      <ProtectedRouteAdmin permission={[all, distributors]}>
        <Layout>
          <UpdateDistributor />
        </Layout>
      </ProtectedRouteAdmin>
    ),
  },
  {
    type: privateType,
    path: "/reports",
    element: (
      <ProtectedRouteAdmin permission={[all]}>
        <Layout>
          <Reports />
        </Layout>
      </ProtectedRouteAdmin>
    ),
  },
  {
    type: privateType,
    path: "/reporteditor",
    element: (
      <ProtectedRouteAdmin permission={[all]}>
        <Layout>
          <ReportEditor />
        </Layout>
      </ProtectedRouteAdmin>
    ),
  },
  {
    type: privateType,
    path: "/uploadscreen",
    element: (
      <ProtectedRouteAdmin permission={[all]}>
        <Layout>
          <UploadComponentpic />
        </Layout>
      </ProtectedRouteAdmin>
    ),
  },
  {
    type: privateType,
    path: "/creategroupreport",
    element: (
      <ProtectedRouteAdmin permission={[all]}>
        <Layout>
          <CreateGroupReport />
        </Layout>
      </ProtectedRouteAdmin>
    ),
  },
  {
    type: privateType,
    path: "/edit_report_group/:id",
    element: (
      <ProtectedRouteAdmin permission={[all]}>
        <Layout>
          <CreateGroupReport />
        </Layout>
      </ProtectedRouteAdmin>
    ),
  },
  {
    type: privateType,
    path: "/edit_report_listing/:id",
    element: (
      <ProtectedRouteAdmin permission={[all]}>
        <Layout>
          <ReportEditor />
        </Layout>
      </ProtectedRouteAdmin>
    ),
  },
  {
    type: privateType,
    path: "/notifications",
    element: (
      <ProtectedRouteAdmin permission={[all]}>
        <Layout>
          <Notifications />
        </Layout>
      </ProtectedRouteAdmin>
    ),
  },
  {
    type: privateType,
    path: "/user-management",
    element: (
      <ProtectedRouteAdmin permission={[all, users]}>
        <Layout>
          <UserManagement />
        </Layout>
      </ProtectedRouteAdmin>
    ),
  },
  {
    type: privateType,
    path: "/create-users",
    element: (
      <ProtectedRouteAdmin permission={[all, users]}>
        <Layout>
          <UpdateUser />
        </Layout>
      </ProtectedRouteAdmin>
    ),
  },

  {
    type: privateType,
    path: "/update-user/:id",
    element: (
      <ProtectedRouteAdmin permission={[all, users]}>
        <Layout>
          <UpdateUser />
        </Layout>
      </ProtectedRouteAdmin>
    ),
  },
  {
    type: privateType,

    path: "/createlocation",
    element: (
      <ProtectedRouteAdmin permission={[all, business]}>
        <Layout>
          <CreateLocation />
        </Layout>
      </ProtectedRouteAdmin>
    ),
  },

  {
    type: privateType,
    path: "/uploadproducts",
    element: (
      <ProtectedRouteAdmin permission={[all, products]}>
        <Layout>
          <UploadComponentData />
        </Layout>
      </ProtectedRouteAdmin>
    ),
  },
  {
    type: privateType,
    path: "/duplicaterecords",
    element: (
      <ProtectedRouteAdmin permission={[all]}>
        <Layout>
          <ImportDuplicates />
        </Layout>
      </ProtectedRouteAdmin>
    ),
  },
  {
    type: privateType,
    path: "/summary",
    element: (
      <ProtectedRouteAdmin permission={[all]}>
        <Layout>
          <ImportSummary />
        </Layout>
      </ProtectedRouteAdmin>
    ),
  },
  {
    type: privateType,
    path: "/kitpdf",
    element: (
      <ProtectedRouteAdmin permission={[all]}>
        <Layout>
          <GeneratePdfKit />
        </Layout>
      </ProtectedRouteAdmin>
    ),
  },
  {
    type: privateType,
    path: "/kitexcel",
    element: (
      <ProtectedRouteAdmin permission={[all]}>
        <Layout>
          <GenerateExcelKit />
        </Layout>
      </ProtectedRouteAdmin>
    ),
  },
  // route for public
  {
    type: publicType,
    path: "/quickreportinfo",
    element: (
      <QuickReportPagesLayout>
        <OnlineQuickPageOne />
      </QuickReportPagesLayout>
    ),
  },
  // Near Miss Report
  {
    type: publicType,
    path: "/near-miss-report-info",
    element: (
      <QuickReportPagesLayout>
        <NearMissPageOne />
      </QuickReportPagesLayout>
    ),
  },
  {
    type: publicType,
    path: "/near-miss-report-summary",
    element: (
      <QuickReportPagesLayout>
        <ReportSummary />
      </QuickReportPagesLayout>
    ),
  },
  {
    type: publicType,
    path: "/quickreportworkplace",
    element: (
      <QuickReportPagesLayout>
        <OnlineQuickPageTwo />
      </QuickReportPagesLayout>
    ),
  },
  {
    type: publicType,
    path: "/quickreportsummary",
    element: (
      <QuickReportPagesLayout>
        <OnlineQuickPageThree />
      </QuickReportPagesLayout>
    ),
  },

  {
    type: publicType,
    path: "/detailedreportinfo",
    element: (
      <QuickReportPagesLayout>
        <DetailedReportPageOne />
      </QuickReportPagesLayout>
    ),
  },
  {
    type: publicType,
    path: "/kit-details",
    element: (
      <QuickReportPagesLayout>
        <KitDetails />
      </QuickReportPagesLayout>
    ),
  },
  {
    type: publicType,
    path: "/detailedreportsummary",
    element: (
      <QuickReportPagesLayout>
        <DetailedReportSummary />
      </QuickReportPagesLayout>
    ),
  },

  {
    type: publicType,
    path: "/detailedreportaction",
    element: (
      <QuickReportPagesLayout>
        <DetailedReportTakeAction />
      </QuickReportPagesLayout>
    ),
  },
  {
    type: publicType,
    path: "/detailedreporforfilleditem",
    element: (
      <QuickReportPagesLayout>
        <DetailedReportFilledItem />
      </QuickReportPagesLayout>
    ),
  },

  {
    type: publicType,
    path: "/detailedincidentreportsummary",
    element: (
      <QuickReportPagesLayout>
        <DetailedIncidentReportSummary />
      </QuickReportPagesLayout>
    ),
  },
  {
    type: publicType,
    path: "/standardwithquickreport",
    element: (
      <QuickReportPagesLayout>
        <StandardWithQuickReport />
      </QuickReportPagesLayout>
    ),
  },
  {
    type: publicType,
    path: "/ID/:id",
    element: <WithOutLoginData />,
  },
  {
    type: publicType,
    path: "/view-batch-kit/:id",
    element: <ViewPDF />,
  },

  // import and export route

  {
    type: privateType,
    path: "/csvupload",
    element: (
      <ProtectedRouteAdmin permission={[all]}>
        <Layout>
          <ImportCsvFiles />
        </Layout>
      </ProtectedRouteAdmin>
    ),
  },

  {
    type: privateType,
    path: "/csvexport",
    element: (
      <ProtectedRouteAdmin permission={[all]}>
        <Layout>
          <ExportCsvFiles />
        </Layout>
      </ProtectedRouteAdmin>
    ),
  },

  {
    type: privateType,
    path: "/multifile",
    element: (
      <ProtectedRouteAdmin permission={[all]}>
        <Layout>
          <MultipleFileUpload />
        </Layout>
      </ProtectedRouteAdmin>
    ),
  },

  // routes for distributor super admin
  // ];

  // export const distrallibutoRoute = [
  {
    type: privateType,
    path: "/distributor",
    element: (
      <ProtectedRouteDistributor permission={distributorAllAccess}>
        <Layout>
          <DistributorDashboard />
        </Layout>
      </ProtectedRouteDistributor>
    ),
  },
  // {
  //   type: privateType,
  //   path: "/distributor/distributor-QR",
  //   element: (
  //     <ProtectedRouteAdmin permission={distributorAllAccess}>
  //       <Layout>
  //         <DistQR />
  //       </Layout>
  //     </ProtectedRouteAdmin>
  //   ),
  // },
  {
    type: privateType,
    path: "/distributor-user-management",
    element: (
      <ProtectedRouteDistributor permission={[dist_super_admin, users]}>
        <Layout>
          <DistributorUserManagement />
        </Layout>
      </ProtectedRouteDistributor>
    ),
  },
  {
    permission: [dist_super_admin, business],

    type: privateType,
    path: "/distributor-business-profile",
    element: (
      <ProtectedRouteDistributor permission={[dist_super_admin, business]}>
        <Layout>
          <DistributorBusinessProfile />
        </Layout>
      </ProtectedRouteDistributor>
    ),
  },
  {
    // permission: [dist_super_admin, business],

    type: privateType,
    path: "/distributor-create-location",
    element: (
      <ProtectedRouteDistributor permission={[dist_super_admin, business]}>
        <Layout>
          <CreateLocation />
        </Layout>
      </ProtectedRouteDistributor>
    ),
  },
  {
    type: privateType,
    permission: [dist_super_admin, clients],
    path: "/distributor-clients",
    element: (
      <ProtectedRouteDistributor permission={[dist_super_admin, clients]}>
        <Layout>
          <DistributorClients />
        </Layout>
      </ProtectedRouteDistributor>
    ),
  },

  // {
  //   type: privateType,
  //   permission: [dist_super_admin, notifications],

  //   path: "/distributor/notifilcation",
  //   element: (
  //     <ProtectedRouteAdmin permission={[dist_super_admin, notifications]}>
  //       <Layout>
  //         <DistributorNotification />
  //       </Layout>
  //     </ProtectedRouteAdmin>
  //   ),
  // },
  {
    type: privateType,
    path: "/distributor-create-user",
    element: (
      <ProtectedRouteDistributor permission={[dist_super_admin, users]}>
        <Layout>
          <DistributorUpdateUser />
        </Layout>
      </ProtectedRouteDistributor>
    ),
  },
  // {
  //   type: privateType,
  //   path: "/distributor-invite-admin",
  //   element: (
  //     <ProtectedRouteDistributor permission={[dist_super_admin, users]}>
  //       <Layout>
  //         <DistributorInviteAdmin />
  //       </Layout>
  //     </ProtectedRouteDistributor>
  //   ),
  // },
  {
    type: privateType,
    path: "/distributor-update-distributor-user/:id",
    element: (
      <ProtectedRouteDistributor permission={[dist_super_admin, users]}>
        <Layout>
          <DistributorUpdateUser />
        </Layout>
      </ProtectedRouteDistributor>
    ),
  },
];

export default RouterData;
